import Button from "components/Button";
import Spinner from "components/Spinner";
import TaggedText from "components/TaggedText";

import Messages from "misc/Messages";

import { ModalButtonsSection, ModalContent, ModalSections } from "./index";


export function CheckingUnpaidInvoicesModalContent() {
  return (
    <ModalContent>
      <ModalSections>
        <div className="flex flex-row gap-x-3">
          <p>Checking your invoices...</p>
          <Spinner className="w-5 h-5 animate-spin" />
        </div>
      </ModalSections>
    </ModalContent>
  );
}

export function DisabledBecauseOfUnpaidInvoicesModalContent(
  {
    closeModalCallback
  }: {
    closeModalCallback: () => void;
  }
) {
  return (
    <ModalContent>
      <ModalSections>
        <TaggedText message={ Messages.cannotCancelBecauseOfUnpaidInvoicesMessage } tagCallbacks={ { 'contact_support': closeModalCallback } } />
      </ModalSections>
      <ModalButtonsSection>
        <Button
          text="Ok"
          className="button button-primary"
          onClick={ closeModalCallback }
          size="MD"
        />
      </ModalButtonsSection>
    </ModalContent>
  );
}
